import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appCategory',
  isDragable: true,
  canOpen: false,
  canChangePosition: true,
  sortingPositionIndex: 'sortingIndex',
  canEdit: true,
  canCreate: true,
  canRemove: true,
  bulkSelectable:true,
  bulkButtons:[
      // {label:"Import categories",
      //   color:ButtonTheme.INFO,
      //   action:"bulkImport",
      //   actionUrl:"appCategory/bulkImport",
      //   type:BulkImportTypes.CATEGORIES,
      //   title:"Import elements",
      //   showNumberElems:false,
      //   hidden:'never',
      //   sessionParams: ['appId', 'areaId'],
      //   formConfig:[
      //     {
      //       attributeName: 'type',
      //       helpText: 'Type of import',
      //       type: FormInputTypes.TEXT_INPUT.TEXT,
      //       required: true,
      //       label: 'Type',
      //       defaultValue:BulkImportTypes.CATEGORIES,
      //       // hidden:true
      //     }
      //   ]
      // },
      {label:"Delete",
        color:ButtonTheme.ERROR,
        action:"bulkDelete",
        title:"Select records to delete",
        showNumberElems:true,
        disabled:'no-selection',
        hidden:'no-selection'
      },
      {label:"Clone",
        color:ButtonTheme.DARK,
        action:"bulkClone",
        title:"Clone records",
        showNumberElems:true,
        disabled:'no-selection',
        hidden:'no-selection'
      },
      // {label:"Export",
      //   color:ButtonTheme.INFO,
      //   action:"bulkExport",
      //   title:"Export records",
      //   type:BulkImportTypes.CATEGORIES,
      //   showNumberElems:true,
      //   disabled:'no-selection',
      //   hidden:'no-selection'
      // }
    ],
  isMultiSelectable:true,
  emptyMessage: "You don't have categories, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of the category.',
    },
    {
      attributeName: 'rows',
      label: 'Mobile Rows',
      type: FormInputTypes.SELECT,
      default: [1],
      width: '12rem',
      options: [
        { name: 1, value: 1 },
        { name: 2, value: 2 },
        { name: 3, value: 3 },
        { name: 4, value: 4 },
      ],
      canOrder: false,
      canEdit: true,
      canFilter: true,
      canCreate: true,
      helpText: 'Rows to display in mobile devices.',
      exactWidth:'100px'
    },
    {
      attributeName: 'hidden',
      label: 'Hidden',
      type: FormInputTypes.CHECKBOX,
      canEdit: true,
      canOrder: false,
      canCreate: false,
      helpText: 'Hide this category if checked.',
      width: '8rem',
      default: false,
      exactWidth:'100px'
    },
    {
      attributeName: 'allVideos',
      label: 'Has All Videos',
      default: false,
      type: FormInputTypes.RADIO,
      canEdit: true,
      canOrder: false,
      canCreate: false,
      width: '12rem',
      helpText: 'The category with all videos.',
      exactWidth:'100px',

    },
    {
      attributeName: 'default',
      label: 'Is Default',
      default: false,
      type: FormInputTypes.RADIO,
      canEdit: true,
      canCreate: false,
      canOrder: false,
      width: '9rem',
      helpText: 'The category selected when the user opens the app.',
      exactWidth:'100px'
    },
    {
      attributeName: 'sortingIndex',
      label: 'Pos',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      default: [],
      width: '3rem',
      exactWidth:'50px',
      small:true

    },
  ],
};
